import {enableTooltips} from "../helpers/content_builders";
import {disposeTooltips} from "../../helpers/tooltips";
import {disposeGraphsInScope} from "../../helpers/graph_registry";

export class BaseDashlet {
    constructor(slotNumber) {
        this.slotNumber = slotNumber;
        this.id = "dash_" + slotNumber;
        this.size = 3;
        this.setupDone = false;
        // For multi-period LTS support
        this.buttons = [];
        this.graphs = [];
        this.graphDivs = [];
        this.zoomed = false;
        this._timeGraphHandlers = [];
    }

    canBeSlowedDown() {
        return false;
    }

    sizeClasses() {
        switch (this.size) {
            case 1: return  ["col-xs-12", "col-sm-12", "col-md-6", "col-lg-3", "col-xl-1", "col-xxl-1"];
            case 2: return  ["col-xs-12", "col-sm-12", "col-md-6", "col-lg-3", "col-xl-2", "col-xxl-2"];
            case 3: return  ["col-xs-12", "col-sm-12", "col-md-6", "col-lg-3", "col-xl-3", "col-xxl-3"];
            case 4: return  ["col-xs-12", "col-sm-12", "col-md-6", "col-lg-6", "col-xl-4", "col-xxl-4"];
            case 5: return  ["col-xs-12", "col-sm-12", "col-md-6", "col-lg-6", "col-xl-5", "col-xxl-5"];
            case 6: return  ["col-xs-12", "col-sm-12", "col-md-6", "col-lg-6", "col-xl-6", "col-xxl-6"];
            case 7: return  ["col-xs-12", "col-sm-12", "col-md-12", "col-lg-12", "col-xl-7", "col-xxl-7"];
            case 8: return  ["col-xs-12", "col-sm-12", "col-md-12", "col-lg-12", "col-xl-8", "col-xxl-8"];
            case 9: return  ["col-xs-12", "col-sm-12", "col-md-12", "col-lg-12", "col-xl-9", "col-xxl-9"];
            case 10: return ["col-xs-12", "col-sm-12", "col-md-12", "col-lg-12", "col-xl-10", "col-xxl-10"];
            case 11: return ["col-xs-12", "col-sm-12", "col-md-12", "col-lg-12", "col-xl-11", "col-xxl-11"];
            case 12: return ["col-xs-12", "col-sm-12", "col-md-12", "col-lg-12", "col-xl-12", "col-xxl-12"];
            default: return ["col-3"];
        }
    }

    title() {
        return "Someone forgot to set a title";
    }

    tooltip() {
        return null;
    }

    subscribeTo() {
        return [];
    }

    onMessage(msg) {
        console.log(msg);
    }

    setupOnce(msg) {
        if (!this.setupDone) {
            this.setup(msg);
        }
        this.setupDone = true;
        enableTooltips(document.getElementById(this.id) || document);
    }

    setup() {}

    graphDivId() {
        if (this.zoomed) {
            return this.id + "_zoomed_graph";
        } else {
            return this.id + "_graph";
        }
    }

    graphDiv() {
        let graphDiv = document.createElement("div");
        graphDiv.id = this.id + "_graph";
        graphDiv.classList.add("dashgraph");
        return graphDiv;
    }

    buildContainer() {
        let div = document.createElement("div");
        div.id = this.id;
        if (this.tag) {
            div.setAttribute("data-dashlet-tag", this.tag);
        }
        let sizeClasses = this.sizeClasses();
        for (let i=0; i<sizeClasses.length; i++) {
            div.classList.add(sizeClasses[i]);
        }
        div.classList.add("dashbox");

        let title = document.createElement("h5");
        title.id = this.id + "_title";
        this.titleId = title.id;
        title.classList.add("dashbox-title");
        title.innerText = this.title();

        let tt = this.tooltip();
        if (tt !== null) {
            let tooltip = document.createElement("span");
            tooltip.style.marginLeft = "5px";
            let button = document.createElement("a");
            //button.type = "button";
            //button.classList.add("btn", "btn-sm", "btn-info");
            button.title = tt;
            button.setAttribute("data-bs-toggle", "tooltip");
            button.setAttribute("data-bs-placement", "top");
            button.setAttribute("data-bs-html", "true");
            button.innerHTML = "<i class='fas fa-info-circle'></i>";
            tooltip.appendChild(button);
            title.appendChild(tooltip);
        }

        if (this.supportsZoom()) {
            let zoom = document.createElement("span");
            zoom.style.marginLeft = "5px";
            let button = document.createElement("a");
            button.title = "Zoom";
            button.innerHTML = "<i class='fas fa-search-plus'></i>";
            button.onclick = () => {
                if (!this.zoomed) {
                    let zoomDiv = document.createElement("div");
                    zoomDiv.classList.add("zoomed");
                    zoomDiv.id = this.id + "_zoomed";
                    zoomDiv.classList.add("dashbox");

                    let title = document.createElement("h5");
                    title.classList.add("dashbox-title");
                    title.innerText = this.title();

                    let button = document.createElement("a");
                    button.title = "Zoom";
                    button.innerHTML = "<i class='fas fa-search-minus'></i>";
                    button.style.marginLeft = "5px";
                    button.onclick = () => {
                        disposeTooltips(zoomDiv);
                        disposeGraphsInScope(zoomDiv);
                        document.getElementById(zoomDiv.id).remove();
                        this.zoomed = false;
                        const dashletRoot = document.getElementById(this.id);
                        if (dashletRoot) {
                            disposeGraphsInScope(dashletRoot);
                            requestAnimationFrame(() => {
                                this.setup();
                                enableTooltips(dashletRoot);
                            });
                        }
                    };
                    title.appendChild(button);

                    zoomDiv.appendChild(title);

                    let graphDiv = document.createElement("div");
                    graphDiv.id = zoomDiv.id + "_graph";
                    graphDiv.classList.add("dashgraphZoomed");
                    zoomDiv.appendChild(graphDiv);

                    document.getElementById("content").insertBefore(zoomDiv, document.getElementById("content").firstChild);

                    requestAnimationFrame(() => {
                        this.setup();
                        enableTooltips(zoomDiv);
                        zoomDiv.scrollIntoView({behavior: "smooth"});
                    });
                }
                this.zoomed = !this.zoomed;
            }
            zoom.appendChild(button);
            title.appendChild(zoom);
        }

        div.appendChild(title);

        return div;
    }

    supportsZoom() {
        return false;
    }

    makePeriodBtn(name) {
        let btn = document.createElement("button");
        btn.classList.add("btn", "btn-sm", "btn-outline-primary", "tiny", "me-1");
        btn.innerText = name;
        btn.id = this.graphDivId() + "_btn_" + name;
        btn.onclick = () => {
            this.buttons.forEach((b) => {
                b.classList.remove("active");
                let targetName = "#" + b.id.replace("_btn", "");
                if (targetName.lastIndexOf("Live") > 0) {
                    targetName = "#" + this.graphDivId();
                }
                if (b === btn) {
                    b.classList.add("active");
                    $(targetName).show();
                } else {
                    $(targetName).hide();
                }
            });
            this.graphs.forEach((g) => {
                g.chart.resize();
            });
        }
        this.buttons.push(btn);
        return btn;
    }

    onTabActivated() {
        // Called when the tab containing this dashlet becomes active
        // Default implementation resizes ECharts instances
        if (this.graphs && this.graphs.length > 0) {
            this.graphs.forEach((g) => {
                if (g.chart && g.chart.resize) {
                    g.chart.resize();
                }
            });
        }
        // Individual dashlets can override this method for custom behavior
    }

    // Explain support (optional per dashlet)
    canExplain() {
        return false;
    }

    isExplainReady() {
        return false;
    }

    explain() {
        return null;
    }

    registerTimeGraphHandler(handler = this) {
        if (window.timeGraphs && Array.isArray(window.timeGraphs)) {
            window.timeGraphs.push(handler);
            this._timeGraphHandlers.push(handler);
        }
        return handler;
    }

    dispose() {
        this._timeGraphHandlers.forEach((handler) => {
            if (!window.timeGraphs || !Array.isArray(window.timeGraphs)) {
                return;
            }
            let idx = window.timeGraphs.indexOf(handler);
            while (idx >= 0) {
                window.timeGraphs.splice(idx, 1);
                idx = window.timeGraphs.indexOf(handler);
            }
        });
        this._timeGraphHandlers = [];

        const ownedGraphs = new Set();
        this.graphs.forEach((graph) => {
            if (graph) {
                ownedGraphs.add(graph);
            }
        });
        if (this.graph) {
            ownedGraphs.add(this.graph);
        }

        ownedGraphs.forEach((graph) => {
            if (graph && typeof graph.dispose === "function") {
                graph.dispose();
            } else if (graph?.chart?.dispose) {
                graph.chart.dispose();
            }
        });
        this.graphs = [];
        this.graph = null;

        const root = document.getElementById(this.id);
        if (root) {
            disposeTooltips(root);
            disposeGraphsInScope(root);
        }

        const zoomRoot = document.getElementById(this.id + "_zoomed");
        if (zoomRoot) {
            disposeTooltips(zoomRoot);
            disposeGraphsInScope(zoomRoot);
            zoomRoot.remove();
        }
        this.setupDone = false;
    }
}
